<template>
  <a-modal title="调整心愿值"
           :open="modal"
           :confirm-loading="loading"
           :mask-closable="false"
           ok-text="保存" @ok="okCk"
           cancel-text="关闭" @cancel="cancelCk">
    <a-form ref="form"
            size="small"
            :model="entity"
            :rules="rules">
      <a-form-item label="数量" name="num">
        <a-input-number v-model:value="entity.num"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'
import {message} from 'ant-design-vue'

const emits = defineEmits(['refresh'])

const modal = ref(false)
const loading = ref(false)
const form = ref(null)
const entity = ref({})

const rules = {
  num: [{
    required: true,
    message: '数量不能为空',
    trigger: 'blur'
  }],
}

let userId, itemId

function openCk(id, item) {
  userId = id
  itemId = item
  modal.value = true
}

function okCk() {
  loading.value = true

  form.value.validate().then(() => {
    axios.post(`/user/${userId}/draw-point/${itemId}`, {
      itemId: itemId,
      num: entity.value.num,
    }).then((res) => {
      loading.value = false

      if (res.code === 1) {
        message.success('操作成功')
        emits('refresh')
        modal.value = false
        form.value.resetFields()
      }
    })
  }).catch(() => {
    loading.value = false
  })
}

function cancelCk() {
  modal.value = false
  form.value.resetFields()
  loading.value = false
}

defineExpose({openCk})
</script>
